import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useRouter } from '~/utils/navigation';
import styled from 'styled-components';
import queryString from 'query-string';
import IconLoading from '~/components/misc/loading-animation.js';
import useLoginFlow from '~/hooks/use-login-flow.js';
import { ROUTE_EXTERNAL_LOGIN } from '../router/constants.js';

const Overlay = styled.div`
	z-index: 2;
	background: #00000099;
`;

const GuestFlowAutostart = () => {
	const { initializeLogin } = useLoginFlow();
	const router = useRouter();
	const location = useLocation();
	const queryParams = queryString.parse(location.search);
	const [isLoading, setLoading] = useState(true);

	// forward to right login on mount
	useEffect(() => {
		const { type } = queryParams;
		if (type) {
			if (type === 'guest-deposit-login') {
				router.push(`${ROUTE_EXTERNAL_LOGIN}${location.search}`);
			} else if (type === 'guest-login') {
				initializeLogin({
					from: location
				});
			}
		}
		setLoading(false);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	if (!queryParams?.type) {
		return null;
	}

	return isLoading ? (
		<>
			<Overlay className="spinner-overlay" />
			<IconLoading />
		</>
	) : null;
};

export default GuestFlowAutostart;
